<div class="selectorCard" [ngClass]="cardColour">
  <div>
    <div class="selectButtonText">{{ value }}</div>
  </div>
</div>
